module.exports = __webpack_public_path__ + "img/hr-level2addon_running_gun.fb911a51.png";